import { render, staticRenderFns } from "./TwIpDnArchiveDetailInner.vue?vue&type=template&id=7d8e3493&scoped=true&"
import script from "./TwIpDnArchiveDetailInner.vue?vue&type=script&lang=js&"
export * from "./TwIpDnArchiveDetailInner.vue?vue&type=script&lang=js&"
import style0 from "./TwIpDnArchiveDetailInner.vue?vue&type=style&index=0&id=7d8e3493&lang=scss&scoped=true&"
import style1 from "./TwIpDnArchiveDetailInner.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8e3493",
  null
  
)

export default component.exports